export default __webpack_public_path__ + "static/media/atlantic.989fee78.png";